import { useEffect, useRef, useState } from 'react';

export interface CountdownTime {
  minutes: number;
  seconds: number;
}

interface UseTimerProps {
  initialMinutes?: number;
}

export const useTimer = ({ initialMinutes = 20 }: UseTimerProps = {}) => {
  const [timeLeft, setTimeLeft] = useState<CountdownTime>({ minutes: initialMinutes, seconds: 0 });
  const endTimeRef = useRef(Date.now() + initialMinutes * 60 * 1000);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const calculateTimeLeft = () => {
    const now = Date.now();
    const diff = endTimeRef.current - now;
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    return { minutes, seconds };
  };

  const tick = () => {
    const newTime = calculateTimeLeft();
    setTimeLeft(newTime);
  };

  const reset = () => {
    endTimeRef.current = Date.now() + initialMinutes * 60 * 1000;
    tick();
  };

  const extend = () => {
    endTimeRef.current = Date.now() + initialMinutes * 60 * 1000;
    tick();
  };

  const isFinished = timeLeft.minutes < 1 && timeLeft.seconds < 1;

  useEffect(() => {
    intervalRef.current = setInterval(tick, 1000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return { time: timeLeft, reset, extend, isFinished };
};
